var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,2C15.432,2,2,15.432,2,32s13.432,30,30,30s30-13.432,30-30S48.568,2,32,2z M32,59.5C16.836,59.5,4.5,47.164,4.5,32 S16.836,4.5,32,4.5c15.163,0,27.5,12.336,27.5,27.5S47.163,59.5,32,59.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32 41.834c-4.538 0-8.082 3.058-9.837 6.492-.47.918.155 1.912.849 1.339 5.758-4.771 12.184-4.8 17.977 0 .693.573 1.318-.421.848-1.339-1.755-3.434-5.298-6.492-9.837-6.492"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.799 30.699c.036-.076.045-.159.043-.246 1.103.833 2.165 1.767 3.262 2.863-.203-1.885-1.125-3.654-2.365-5.115-1.25-1.461-2.852-2.641-4.596-3.441-1.75-.811-3.67-1.262-5.59-1.279-1.914-.008-3.801.42-5.387 1.455 1.531.148 2.885.359 4.212.665-.057.05-.106.106-.138.175-1.361 2.916-.1 6.381 2.814 7.742 2.919 1.359 6.384.097 7.745-2.819"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m48.447 23.48c-1.92.018-3.84.469-5.59 1.279-1.744.801-3.346 1.98-4.596 3.441-1.24 1.461-2.162 3.23-2.365 5.115 1.097-1.097 2.159-2.03 3.262-2.863-.002.087.007.17.043.246 1.361 2.916 4.826 4.178 7.744 2.818 2.914-1.361 4.176-4.826 2.814-7.742-.032-.068-.081-.125-.138-.175 1.327-.306 2.682-.517 4.212-.665-1.585-1.034-3.472-1.461-5.386-1.454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.816dad3733c343df497822f9c00139d0.svg";
export { ForwardRef as ReactComponent };